<template>
  <div class="Chamber">

    <div class="chamber-header">
      <h2>{{chamber.name}}</h2>
    </div>

    <div class="sources">
      <div v-for="source in sourcesByChamberId(chamber.id)" :key="'S'+source.id" class="source-container">
        <Source :source="source" />
      </div>
    </div>

    <hr />

    <div class="articles">
      <div v-for="(article) in articlesByChamberId(chamber.id,true)" :key="'A'+article.id">
        <div class="article-container">
          <Article :article="article" />
        </div>
        <div v-if="discussionTest()" class="article-container">
          <ThemeQuestion :theme="getThemeById(chamber.idTheme)"></ThemeQuestion>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import Source from '@/components/Source.vue'
import Article from '@/components/Article.vue'
import ThemeQuestion from '@/components/ThemeQuestion.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'Chamber',
  components: {
    Source,
    Article,
    ThemeQuestion
  },
  data: function () {
    return {
      //name: "name"
    }
  },
  props: {
    chamber: Object
  },
  computed: {
    ...mapGetters('themes',[
      'getThemeById',
    ]),
    ...mapGetters('sources',[
      'sourcesByChamberId',
    ]),
    ...mapGetters('articles',[
      'articlesByChamberId',
    ])
  },
  methods: {
    discussionTest: function () {
      return Math.random() > 0.9;
    }
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.Chamber{
  padding: 0 10px 0 10px;
}

.chamber-header{
}

.sources{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 5px;
}

.source-container{
  margin: 0 5px 5px 0;
}

.articles{
  display: flex;
  flex-direction: column;
}

.article-container {
  margin-bottom: 15px;
  border-top: var(--border);
  border-left: var(--border);
  border-bottom: var(--border-dark);
  border-right: var(--border-dark);
}

.article-container:hover{
  border-top: var(--border-dark);
  border-left: var(--border-dark);
  border-bottom: var(--border-black);
  border-right: var(--border-black);
  //box-shadow: 2px 2px 0px black;
}

</style>
